export default __webpack_public_path__ + "static/media/ms.3db460b5.svg";